import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import { iv } from './iv';
import { cp } from './cp';
import cView from './cView';

export default class cPdtCtgDtl extends cView{

  $id_stgs = {
  };

  $cd_stss = {
  }

  $clp_loads = () => [
    cp.$cp_hlr_cm5t({
      mode: 'set',
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show') ? false: true,
      cnd: bf.q('[_KEY]={}'.f(
        global.c?.state.sgcd_pageCmns?.cm5t_key
      )),
    }),
  ];

  $cp_ins = () => new Promise( _o_end1 => {
//bf.l('31:here')
    cp.$cp_hlr_cm5t({
      mode: 'ins',
    })
    .then( _d_is => {
//bf.l('35:{}'.f(_d_is))
      cf.myRN_setCmns({
        cm5t_key: _d_is._KEY,
      })
      .then(() => {
        _o_end1(_d_is);
      });
    });
  });

  $clp_upds = () => [
    cp.$cp_hlr_cm5t({
      mode: 'ups',
      cnd: bf.q('[_KEY]={}'.f(
        global.c?.state.sgcd_pageCmns?.cm5t_key
      )),
    })
  ];    

  //
  render(){
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={{
          pfx: '商品情報',
          d_leftBtns: {},
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5tc310',
              pfx:'商品分類名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5tcx10',
              pfx:'表示順',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5tcz10',
              pfx:'表示の有無',
              ini: '10',
              ld_itemss: [
                {key:'10', pfx: '表示する'},
                {key:'0', pfx: '表示しない'},
              ],
              b_setValOnChg:false,
            },

          ],
        }}
      />
    );
  }        
}
